export default (Alpine) => {
    Alpine.data("productStats", () => ({
        scrollY: 0,


      
      init() {


        window.addEventListener('scroll', this.scrolling.bind(this));
      },

      scrolling() {
        this.scrollY = window.scrollY;
      },

    }));
  };